import PaymentScheduleScreen from 'features/lineOfCredit/screens/paymentSchedule/PaymentSchedule';
import React from 'react';

export default function Page() {
  return <PaymentScheduleScreen />;
}
